import { SessionStorageKeys } from '@aglenergy/shared-library';
import { ObservableMap } from '@stencil/store';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { BundleSearchStore } from 'app/shared/models/current-search-request.model';
import { ProductCategory } from 'app/shared/models/product-category.model';
import { removeHandler } from 'app/shared/store/handlers/types/remove-handler';
import { State } from 'app/shared/store/models/state.model';

export const guidedFlowActiveCategoryHandler = (store: ObservableMap<State>): removeHandler => {
  const activeCategory = store.get('guidedFlowActiveCategory');
  handleCategoryChange(activeCategory, store);
  if (activeCategory && activeCategory !== 'none' && !store.get('productCategory')) {
    store.set('productCategory', activeCategory);
  }
  return store.onChange(StoreKeys.guidedFlowActiveCategory, (category) => {
    if (category !== 'none') {
      store.set('productCategory', category);
    }
    handleCategoryChange(category, store);
  });
};

const handleCategoryChange = (category: ProductCategory | 'none', store: ObservableMap<State>) => {
  if (category === 'nbn') {
    const productSessionData = JSON.parse(sessionStorage.getItem(SessionStorageKeys.bundleProducts)) as BundleSearchStore;
    store.set('productDetails', productSessionData.nbnResponse);
  } else if (category === 'mobile plan') {
    const productSessionData = JSON.parse(sessionStorage.getItem(SessionStorageKeys.bundleProducts)) as BundleSearchStore;
    store.set('productDetails', productSessionData.mobileResponse);
  }
};
